import {BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Reset from './Auth/Reset'
import Cart from './Cart/Cart.jsx'
import {Contact} from './Contact/Contact.jsx'
import Home from './Home/Home.jsx'
import Products from './Home/Products/Products.jsx'
import Register from './Auth/Register'
import Login from './Auth/Login.jsx'
import Admin from './Admin/Admin.jsx';
import AddProduct from './Admin/AddProduct'
import ViewOrderStatus from './Admin/ViewOrderStatus.jsx'
import ViewProducts from './Admin/ViewProducts';
import Search from './Home/Search/Search'
import Checkout from './Checkout/Checkout'
import ProductDetail from './Home/Products/ProductDetail'
import ShippingForm from './Checkout/ShippingForm'
import ConfirmOrder from './Checkout/ConfirmOrder'
import PrevOrders from './previousOrders/PrevOrders'
import ProductRating from './ProductRating/ProductRating'

import OrderData from './Admin/OrderData'
import AdminRoutes from '../HideRoutes/AdminRoutes'
import PageNotFount from './PageNotFount'



export default function Routess() {
    const location = useLocation()
  return (
<Routes  location={location} key={location.pathname}>
    <Route path="/" element={<Home/>} />
    <Route path= "products" element={<Products/>}/>
    <Route path= "/product/details/:idParam" element={<ProductDetail/>}/>
    <Route path="search" element={<Search/>}/>
    <Route path="/cart" element={<Cart/>} />
    <Route path="cart/ShippingForm" element={<ShippingForm/>} />
    <Route path="cart/ShippingForm/Checkout" element={<Checkout/>} />
    <Route path="cart/ShippingForm/Checkout/ConfirmOrder" element={<ConfirmOrder/>} />
    <Route path="/ProductRating/:idParam" element={<ProductRating/>} />
    <Route path="/PrevOrders" element={<PrevOrders/>} />
    <Route path="/contact" element={<Contact/>} />
    <Route path="register" element={<Register/>} />
    <Route path="/login" element={<Login/>} />
    <Route path="reset" element={<Reset/>} />
    <Route path="*" element={<PageNotFount/>} />


    <Route path="/Admin" element={<AdminRoutes><Admin/></AdminRoutes>} />
    <Route path="/Admin/AddProduct/:idParam" element={<AdminRoutes><AddProduct/></AdminRoutes>} />
    <Route path="/Admin/ViewOrderStatus" element={<AdminRoutes><ViewOrderStatus/></AdminRoutes>} />
    <Route path="/Admin/ViewProducts" element={<AdminRoutes><ViewProducts/></AdminRoutes>}></Route>
    <Route path="/Admin/ViewOrderStatus/OrderData/:idParam" element={<AdminRoutes><OrderData/></AdminRoutes>} />

</Routes>
  )
}
